var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowSmallLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12.848,
    viewBox: "0 0 15 12.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-small-left",
    d: "M35.357,26.784H24.643l3.525-3.525a1.072,1.072,0,1,0-1.511-1.521l-4.6,4.607a2.143,2.143,0,0,0-.632,1.511h0a2.143,2.143,0,0,0,.632,1.5l4.6,4.607a1.072,1.072,0,0,0,1.511-1.521l-3.525-3.514H35.357a1.071,1.071,0,1,0,0-2.143Z",
    transform: "translate(-21.429 -21.426)",
    fill: "#3160d4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallLeft);
export default __webpack_public_path__ + "static/media/arrowSmallLeft.9c451966bd10538d141b077aea283473.svg";
export { ForwardRef as ReactComponent };